import {Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {MatRadioChange} from '@angular/material/radio';
import {ReportParameterModel} from '../models/ReportParameterModel.model';
import {DomSanitizer} from '@angular/platform-browser';
import {ReportViewerParameterModel} from '../models/ReportViewerParameterModel.model';
import {ReportsService} from '../reports.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ReportCategoryModel} from '../models/ReportCategoryModel.model';
import {DataTypeEnum} from '../../../models/enum/data-type.enum';
import {ReportListModel} from '../models/ReportListModel.model';
import {TdoDropdownModel} from '../../../tdo-controls/common/tdo-basic-dropdown/models/tdo-dropdown.model';
import {StaticDataService} from '../../../services/static-data.service';
import {EnumValidValueItemModel} from '../../../models/enum/enum-valid-value-item.model';
import {MatSelectChange} from '@angular/material/select';
import {TdoTableRowModel} from '../../../tdo-controls/common/tdo-table-v2/models/tdo-table-row.model';
import {MatListOption} from '@angular/material/list';
import {Globals} from '../../../globals';
import {ReportStartUpObjectModel} from '../models/ReportStartUpObject.model';
import {ReportAgingFilterModel} from '../models/ReportAgingFilterModel.model';
import {ReportAgingFilterComponent} from '../report-viewer-filters/report-aging-filter/report-aging-filter.component';
import {
  ReportFinancialSummaryFilterComponent
} from '../report-viewer-filters/report-financial-summary-filter/report-financial-summary-filter.component';
import {ReportFinancialFilterModel} from '../models/ReportFinancialFilterModel.model';
import {DatePipe} from '@angular/common';
import {ReportFinancialSnapshotFilterModel} from '../models/ReportFinancialSnapshotFilterModel.model';
import {
  ReportFinancialSnapshotFiltersComponent
} from '../report-viewer-filters/report-financial-snapshot-filters/report-financial-snapshot-filters.component';
import {environment} from '../../../../environments/environment';
import {ReportFinancialSnapshotComponent} from '../report-financial-snapshot/report-financial-snapshot.component';
// import { ajaxSetup } from '@devexpress/analytics-core';
import {Router} from '@angular/router';
import {
  ReportFrontDeskFiltersComponent
} from '../report-viewer-filters/report-front-desk-filters/report-front-desk-filters.component';
import {ReportFrontDeskFilterModel} from '../models/ReportFrontDeskFilterModel.model';
import {EnterpriseService} from '../../../services/enterprise.service';
import {ReportCategory, ReportClass, ReportIDEnum} from '../../../models/enum/report-ID-enum';
import {ConversionUtilities} from '../../../utilities/conversion.utilities';
import {DxReportViewerComponent} from 'devexpress-reporting-angular';
import {Subscription} from 'rxjs';
import {MessagingConstants} from '../../../models/MessagingConstants';
import {MessagingService} from '../../../services/messaging.service';
import {UiService} from '../../../services/ui.service';
import {
  ReportLetterSubstituteParameterModel,
  ReportsLetterSubstituteModel
} from '../models/ReportsLetterSubstituteModel';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {concatMap} from "rxjs/operators";
// import DevExpress from 'devextreme';
// import DevExpress from '@devexpress/analytics-core';
// import Report from 'devexpress-reporting/dx-webdocumentviewer';
// import  {DevExpress  from "@devexpress/analytics-core";

export interface IParams {
  isProvider: boolean;
  isPractice: boolean;
  PracticeId: number;
  ProviderId: string;
  PracticeLocations: string[];
  ProvidersId: string[];
  initialDate: string;
  endDate: string;
  isAsc: boolean;
  showInactive: boolean;
  reportName: string;
  dateRange: string;
  CurrentLocation: string;
}

@Component({
  selector: 'app-report-viewer',
  templateUrl: './report-viewer-dialog.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: [
    './report-viewer-dialog.component.css',
    '../../../../../node_modules/jquery-ui/themes/base/all.css',
    '../../../../../node_modules/devextreme/dist/css/dx.common.css',
    '../../../../../node_modules/devextreme/dist/css/dx.light.css',
    '../../../../../node_modules/@devexpress/analytics-core/dist/css/dx-analytics.common.css',
    '../../../../../node_modules/@devexpress/analytics-core/dist/css/dx-analytics.light.css',
    '../../../../../node_modules/devexpress-reporting/dist/css/dx-webdocumentviewer.css'
  ]
})


export class ReportViewerDialogComponent implements OnInit {
  private storedUser = JSON.parse(localStorage.getItem('storedUser'));

  // ajaxSetup = DXAnalytics.Analytics.Utils.ajaxSetup;
  constructor(
    public domSanitizer: DomSanitizer,
    private reportService: ReportsService,
    private snackBar: MatSnackBar,
    private staticDataService: StaticDataService,
    private globals: Globals,
    private datePipe: DatePipe,
    private router: Router,
    private enterpriseService: EnterpriseService,
    private messagingService: MessagingService,
    private uiService: UiService
  ) {
    /* this.ajaxSetup.ajaxSettings = {
      headers: {
      Authorization: 'Bearer ' + this.storedUser.authToken
        }
      }
    DevExpress.Reporting.Viewer.Settings.AsyncExportApproach = true;*/

    /* report.Reporting.Viewer.Settings.AsyncExportApproach = true;
this.ajaxSetup.ajaxSettings = { headers: this.storedUser.authToken };*/
    window.resizeTo(screen.width, screen.height);
  }

  reportCategoryEnumItems: EnumValidValueItemModel[];
  reportByCategoryEnumItems: EnumValidValueItemModel[];
  // enterpriseModel: TdoEnterpriseConfigurationModel;
  enterpriseId: string = '';

  reportStartUpObject: ReportStartUpObjectModel;
  patientId: string;
  enumReportCategoryId: string;
  reportId: string;
  // Use this line if you use an ASP.NET MVC backend
  // invokeAction = '/WebDocumentViewer/Invoke';
  // Use this line if you use an ASP.NET Core backend
  invokeAction = 'DXXRDV';

  title = 'DXReportViewer';
  reportUrl: string;
  emptyReportUrl: string;
  reportToPDFUrl: string;
  hostUrlDXXRDV: string;
  hostUrlReporting: string;
  // invokeAction = '/DXXRDV';
  reportName = '';
  currentPatientName: string = '';
  hasCurrentPatient: boolean = true;

  // Front Desk Report Child
  frontDeskReportChild: string;
  isEnvelop: boolean = false;
  isTreatmentPlan: boolean = false;

  isLoading: boolean;
  isReportViewer: boolean;
  hasDevReportParam: boolean = true;
  blShowReportsByCategory: boolean;
  blReportByCategorySelected: boolean;
  showAgingFilters: boolean;
  showFinancialSummaryFilters: boolean;
  showFinancialSnapshotFilters: boolean;
  showFrontDeskFilters: boolean;
  selectedEnumReportCategoryID: string;
  selectedEnumReportCategory: any;
  activeReport: ReportListModel;
  reportStartUpInstructions: ReportStartUpObjectModel;
  isSnapShotReport: boolean = false;
  isDailySnapShot: boolean = false;
  isSnapshotDevExpress: boolean = false;


  showParametersForReport: string = '';
  isGeneric: boolean = false;

  reportViewerParameters: ReportViewerParameterModel[] = [];
  reportParameters: ReportParameterModel[] = [];
  reportParametersNumber: ReportParameterModel[] = [];
  reportParametersString: ReportParameterModel[] = [];
  reportParametersBoolean: ReportParameterModel[] = [];
  reportParametersDateTime: ReportParameterModel[] = [];
  reports: ReportListModel[] = [];
  reportCategories: ReportCategoryModel[] = [];

  tempUserFormPasswords: any = [];
  reportAgingFilters: ReportAgingFilterModel;
  reportFinancialFilters: ReportFinancialFilterModel;
  reportFinancialSnapshotFilters: ReportFinancialSnapshotFilterModel;
  reportFrontDeskFilters: ReportFrontDeskFilterModel;
  authToken: string;
  isSpecificReport: boolean = false;
  isEmptyReport: boolean = false;
  messagingSubscription: Subscription;
  showLetterSub: boolean = false;
  ReportsLetterSubstitute: ReportsLetterSubstituteModel;
  isLetterSubstitute: boolean = false;

  @ViewChild(ReportAgingFilterComponent) reportAgingFilter: ReportAgingFilterComponent;
  @ViewChild(ReportAgingFilterComponent) reportPatientStatementFilter: ReportAgingFilterComponent;
  @ViewChild(ReportAgingFilterComponent) reportTransactionFilter: ReportAgingFilterComponent;
  @ViewChild(ReportAgingFilterComponent) reportVoidedTransactionFilter: ReportAgingFilterComponent;
  @ViewChild(ReportAgingFilterComponent) reportLedgerTransactionFilter: ReportAgingFilterComponent;
  @ViewChild(ReportAgingFilterComponent) reportFinancialAuditFilter: ReportAgingFilterComponent;
  @ViewChild(ReportAgingFilterComponent) reportListOfAppointmentsFilter: ReportAgingFilterComponent;
  @ViewChild(ReportAgingFilterComponent) reportFinancialSummaryFilter: ReportAgingFilterComponent;
  @ViewChild(ReportAgingFilterComponent) reportFinancialSnapshotFilter: ReportAgingFilterComponent;
  @ViewChild(ReportAgingFilterComponent) reportCreditBalanceFilter: ReportAgingFilterComponent;
  @ViewChild(ReportAgingFilterComponent) reportCreditCardReceiptFilter: ReportAgingFilterComponent;
  @ViewChild(ReportAgingFilterComponent) reportRecallFilter: ReportAgingFilterComponent;
  @ViewChild(ReportAgingFilterComponent) reportProcedureWithNoClaimsFilter: ReportAgingFilterComponent;
  @ViewChild(ReportAgingFilterComponent) reportClaimsNotSentFilter: ReportAgingFilterComponent;
  @ViewChild(ReportAgingFilterComponent) reportOutstandingClaimsFilter: ReportAgingFilterComponent;
  @ViewChild(ReportAgingFilterComponent) reportBankDepositsFilter: ReportAgingFilterComponent;
  @ViewChild(ReportAgingFilterComponent) reportFeeCalculationReportFilter: ReportAgingFilterComponent;
  @ViewChild(ReportAgingFilterComponent) reportReferringAnalysisFilter: ReportAgingFilterComponent;
  @ViewChild(ReportAgingFilterComponent) reportPatientsNeedAppointmentFilter: ReportAgingFilterComponent;

  @ViewChild(ReportFinancialSummaryFilterComponent) reportFinancialFilter: ReportFinancialSummaryFilterComponent;
  @ViewChild(ReportFinancialSnapshotFiltersComponent) reportFinancialSnapshotBreakDownFilter: ReportFinancialSnapshotFiltersComponent;
  @ViewChild(ReportFinancialSnapshotComponent) ReportFinancialSnapshot: ReportFinancialSnapshotComponent;
  @ViewChild(ReportFrontDeskFiltersComponent) ReportFrontDesk: ReportFrontDeskFiltersComponent;

  @ViewChild(DxReportViewerComponent, {static: false}) viewer: DxReportViewerComponent;


  ngOnInit(): void {
    // get reports
    if (this.globals.currentPatientId === undefined || this.globals.currentPatientId === '') {
      this.snackBar.open('No Active Patient selected', 'TDOX', {
        duration: 3000,
        verticalPosition: 'top'
      });
      this.hasCurrentPatient = false;

      // if not current patient Listening for patient_changed
      this.messagingSubscription = this.messagingService.componentMessageCall
        .subscribe(response => {
          if (response.event === MessagingConstants.PATIENT_CHANGED && response.data.PatientID !== null) {
            this.hasCurrentPatient = true;
          }
        });


    } else {
      this.hasCurrentPatient = true;
    }
    this.reportStartUpObject = JSON.parse(localStorage.getItem('object'));
    if (!this.staticDataService.isReady) {
      this.staticDataService.validValuesReadyEvent.subscribe({
        complete: () => {
          this.setupPage();
        }
      });
    } else {
      this.setupPage();
    }

    this.reportService.getReports()
      .subscribe(response => {
        // reports
        this.reports = response;
        // load page
      }, err => {
        this.showMessage('Error', 'Error getting reports');
        this.isLoading = false;
      });
    // get report category types	
	this.hostUrlDXXRDV = environment.tdoxReportingUrlDXXRDV;
	this.hostUrlReporting = environment.tdoxReportingUrl;
    // this.hostUrl = environment.tdoxReportingUrl + this.storedUser.authdata.userid;
    // this.hostUrl = 'https://tdocxreporting20220902165706.azurewebsites.net/';
    // ajaxSetup.ajaxSettings = { headers: UserService.authorizationHeaderObject };
    this.authToken = this.storedUser.authToken;
    this.enterpriseId = localStorage.getItem('TDOEnterpriseId');
  }

  addItem(newItem: ReportAgingFilterModel) {
    this.reportAgingFilters = newItem;

  }

  addItemFinancial(newItem: ReportFinancialFilterModel) {
    this.reportFinancialFilters = newItem;
  }

  addItemFinancialSnapshot(newItem: ReportFinancialSnapshotFilterModel) {
    this.reportFinancialSnapshotFilters = newItem;
  }

  addItemFrontDesk(newItem: ReportFrontDeskFilterModel) {
    this.reportFrontDeskFilters = newItem;
  }

  setupPage() {
    // create report entry point
    // validate if user needs to perform an action
    if (this.reportStartUpObject.reportStartUpInstructions.ShowViewer) {
      this.isReportViewer = true;
    }
    // patient..... need to validate if the general report viewer will send current PatientID,
    // report categories
    this.reports.forEach(a => {
      if (!this.reportCategories.find(f => f.enumReportCategoryID === a.enumReportCategoryID)) {
        const reportCategory: ReportCategoryModel = new ReportCategoryModel();
        reportCategory.enumReportCategoryID = a.enumReportCategoryID;
        reportCategory.Name = a.CategoryName;
        this.reportCategories.push(reportCategory);
      }
    });
    //

    // Execute Run Report, without additional parameters
    if (this.reportStartUpObject.reportStartUpInstructions.ReportID) {
      this.isSpecificReport = true;
      this.reports = this.reports.filter(a => a.ReportID.toUpperCase() === this.reportStartUpObject.reportStartUpInstructions.ReportID.toUpperCase());
      this.activeReport = this.reports[0];

      // run report
      if (this.reportStartUpObject.reportStartUpInstructions.ReportID === ReportIDEnum.reportID_ARClaim) {
        this.arcClaimParams();
        this.reportName = this.reports[0].ReportName; // for now
        return;
      }

      if (this.reportStartUpObject.reportStartUpInstructions.ReportID === ReportIDEnum.reportID_PatientStatement) {
        this.runReport();
        return;
      }

      if (this.reportStartUpObject.reportStartUpInstructions.ReportID === ReportIDEnum.reportID_FrontDesk_WalkOutSlip) {
        this.runReport();
        return;
      }

      if (this.reportStartUpObject.reportStartUpInstructions.ReportID === ReportIDEnum.reportID_Comparison_Report) {
        this.reportName = 'Comparison Report';
        this.PerioChartComparisonReportParams();
        return;
      }

      if (this.reportStartUpObject.reportStartUpInstructions.ReportID === ReportIDEnum.reportID_PerioChart_Report) {
        this.reportName = 'Perio Chart Report';
        this.PerioChartReportParams();
        return;
      }


    }
    if (this.reportStartUpObject.reportStartUpInstructions.enumReportCategoryID) {
      this.selectedEnumReportCategoryID = this.reportStartUpObject.reportStartUpInstructions.enumReportCategoryID;
      return;
    }
    // no parameters for Report, user needs to select category and report
    if (!this.reportStartUpObject.reportStartUpInstructions.enumReportCategoryID && !this.reportStartUpObject.reportStartUpInstructions.ReportID) {
      this.reportCategoryEnumItems = this.staticDataService.getValidValueItemsByValidValueName('enumReportCategory');
      this.reportByCategoryEnumItems = this.staticDataService.getValidValueItemsByValidValueId(ReportCategory.AccountRecevables);
      this.blShowReportsByCategory = true;
      return;
    }
  }

  resetParamVars() {
    this.reportParameters = [];
    this.reportParametersNumber = [];
    this.reportParametersString = [];
    this.reportParametersBoolean = [];
    this.reportParametersDateTime = [];
  }

  reportSelected(event: MatRadioChange): void {
    // set active
    this.activeReport = event.value;
    // show parameters
    this.showParameters();
  }

  onGroupsChange(options: MatListOption[]) {
    // set active
    this.activeReport = options.map(o => o.value)[0];
    // show parameters
    this.showParameters();
    this.showFilters();

  }

  onReportSelected(report: ReportListModel, event: any) {
    if (event.isUserInput) {
      this.activeReport = report;
      this.reportName = report.ReportName;
      this.isEmptyReport = true;
      // show parameters
      this.showParameters();
      this.showFilters();
      this.isSnapshotDevExpress = false;

      // check if Report has Letter Substitute
      this.reportService.GetLetterSubstitute(this.activeReport.ReportID).subscribe(result => {
        if (result) {
          this.ReportsLetterSubstitute = result;
          this.showLetterSub = true;
          this.isLetterSubstitute = true;
        } else {
          this.showLetterSub = false;
          this.isLetterSubstitute = false;
        }
      });

    }
  }

  private createEnumDropdownModels(enumName: string): TdoDropdownModel[] {
    const enums = this.staticDataService.getValidValueItemsByValidValueName(enumName);
    const ddModels: TdoDropdownModel[] = [];
    if (enums) {
      for (const vvi of enums) {
        ddModels.push(new TdoDropdownModel(vvi.ItemDisplayValue, vvi));
      }
    }
    return ddModels;
  }

  showFilters() {
    this.showAgingFilters = false;
    this.showFinancialSummaryFilters = false;
    this.showFinancialSnapshotFilters = false;
    this.isSnapShotReport = false;
    this.isDailySnapShot = false;
    this.showFrontDeskFilters = false;
    this.showParametersForReport = '';
    this.isGeneric = false;
    this.isEnvelop = false;
    this.isTreatmentPlan = false;


    if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_PatientStatement) {
      this.showAgingFilters = true;
      this.isGeneric = true;
      this.showParametersForReport = ReportIDEnum.reportID_PatientStatement;
    }
    if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_List_of_Appointments) {
      this.showAgingFilters = true;
      this.isGeneric = true;
      this.showParametersForReport = ReportIDEnum.reportID_List_of_Appointments;
    } else if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_AgingAnalysis) {
      this.showAgingFilters = true;
      this.isGeneric = true;
      this.showParametersForReport = ReportIDEnum.reportID_AgingAnalysis;
    } else if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_TransactionReport) {
      this.showAgingFilters = true;
      this.showParametersForReport = ReportIDEnum.reportID_TransactionReport;
    } else if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_VoidedTransactionReport) {
      this.showAgingFilters = true;
      this.isGeneric = true;
      this.showParametersForReport = ReportIDEnum.reportID_VoidedTransactionReport;
    } else if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_Financial_AuditReport) {
      this.showAgingFilters = true;
      this.showParametersForReport = ReportIDEnum.reportID_Financial_AuditReport;
    } else if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_LedgerTransactionReport) {
      this.showAgingFilters = true;
      this.isGeneric = true;
      this.showParametersForReport = ReportIDEnum.reportID_LedgerTransactionReport;
    } else if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_FinancialSummary) {
      // this.showFinancialSummaryFilters = true;
      this.showAgingFilters = true;
      this.isGeneric = true;
      this.showParametersForReport = ReportIDEnum.reportID_FinancialSummary;
    } else if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_FinancialSnapshot) {
      this.showFinancialSnapshotFilters = true;
    } else if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_AllDoctors) {
      this.hasDevReportParam = true;
    } else if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_FinancialSnapshotReport) {
      /* this.showFinancialSnapshotFilters = true;*/
      this.isSnapShotReport = true;
      this.showAgingFilters = true;
      this.isGeneric = true;
      this.showParametersForReport = ReportIDEnum.reportID_FinancialSnapshotReport;
    } else if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_DailySnapshot) {
      this.isSnapShotReport = true;
      this.showAgingFilters = true;
      this.isGeneric = true;
      this.showParametersForReport = ReportIDEnum.reportID_DailySnapshot;
    } else if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_FrontDesk_Envelops) {
      this.showFrontDeskFilters = true;
      this.isEnvelop = true;
    } else if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_FrontDesk_TreatmentPlan) {
      this.showFrontDeskFilters = true;
      this.isTreatmentPlan = true;
    } else if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_FrontDesk_WalkOutSlip) {
      // Do Anything for now
      // this.showFrontDeskFilters = true;
      // this.isTreatmentPlan = true;
    } else if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_Credit_Balance) {
      this.showAgingFilters = true;
      this.isGeneric = true;
      this.showParametersForReport = ReportIDEnum.reportID_Credit_Balance;
    }
    else if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_CreditCardReceiptReport) {
      this.showAgingFilters = true;
      this.isGeneric = false;
      this.showParametersForReport = ReportIDEnum.reportID_CreditCardReceiptReport;
    }
    else if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_RecallReport) {
      this.showAgingFilters = true;
      this.isGeneric = true;
      this.showParametersForReport = ReportIDEnum.reportID_RecallReport;
    }
    else if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_ProceduresWithNoClaims) {
      this.showAgingFilters = true;
      this.isGeneric = true;
      this.showParametersForReport = ReportIDEnum.reportID_ProceduresWithNoClaims;
    }
    else if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_ClaimsNoSent) {
      this.showAgingFilters = true;
      this.isGeneric = true;
      this.showParametersForReport = ReportIDEnum.reportID_ClaimsNoSent;
    }
    else if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_OutstandingClaims) {
      this.showAgingFilters = true;
      this.isGeneric = true;
      this.showParametersForReport = ReportIDEnum.reportID_OutstandingClaims;
    }
    else if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_BankDeposits) {
      this.showAgingFilters = true;
      this.isGeneric = false;
      this.showParametersForReport = ReportIDEnum.reportID_BankDeposits;
    }
    else if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_FeeCalculationReport) {
      this.showAgingFilters = true;
      this.isGeneric = false;
      this.showParametersForReport = ReportIDEnum.reportID_FeeCalculationReport;
    }
    else if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_ReferringAnalysis) {
      this.showAgingFilters = true;
      this.isGeneric = true;
      this.showParametersForReport = ReportIDEnum.reportID_ReferringAnalysis;
    }
    else if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_PatientsNeedAppointment) {
      this.showAgingFilters = true;
      this.isGeneric = false;
      this.showParametersForReport = ReportIDEnum.reportID_PatientsNeedAppointment;
    }
  }

  showParameters() {
    // reset report param vars
    this.resetParamVars();
    // present any parameter inputs
    if (this.activeReport.cfgReportParameters) {
      this.activeReport.cfgReportParameters.forEach(a => {
        // load up params based on type
        if (a.enumDataTypeID) {
          if (a.enumDataTypeID === DataTypeEnum.String) {
            this.reportParametersString.push(a);
          } else if (a.enumDataTypeID === DataTypeEnum.Integer) {
            this.reportParametersNumber.push(a);
          } else if (a.enumDataTypeID === DataTypeEnum.Boolean) {
            this.reportParametersBoolean.push(a);
          } else if (a.enumDataTypeID === DataTypeEnum.DateTime) {
            this.reportParametersDateTime.push(a);
          }
        }
      });
    }
  }

  runReport(): void {
    this.isEmptyReport = false;
    if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_PatientStatement) { // Patient statement
      this.patientStatementParams();
      return;
    }
    if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_List_of_Appointments) { // List of Appointments
      this.listOfAppointmentsParams();
      return;
    } else if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_AllDoctors) { // All Doctors
      this.allDoctorsParams();
      return;
    } else if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_AgingAnalysis) { // Aging Analysis
      this.agingAnalysisParams();
      return;
    } else if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_FinancialSummary) { // Financial Summary
      this.financialSummaryParams();
      return;
    } else if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_FinancialSnapshot) { // Financial Snapshot BreakDown
      this.financialSnapshotBreakDownParams();
      return;
    } else if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_FinancialSnapshotReport) // Snapshot Report
    {
      this.financialSnapshotParams();
      return;
    } else if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_DailySnapshot) // Daily Snapshot Report
    {
      this.financialDailySnapshotParams();
      return;
    } else if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_FrontDesk_Envelops) // Front Desk Envelops
    {
      this.frontDeskEnvelopParams();
      return;
    } else if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_FrontDesk_TreatmentPlan) // Front Desk Treatment Plan
    {
      this.frontDeskTreatmentPlanParams();
      return;
    } else if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_FrontDesk_WalkOutSlip) // Front Desk Walk Out Slip
    {
      this.frontDeskWalkOutSlip();
      return;
    } else if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_BankDeposits  ) // Bank Deposits
    {
      this.bankDeposits();
      return;
    } 
    else if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_FeeCalculationReport  ) // Fee Calculation Report
    {
      this.feeCalculationReport();
      return;
    } 
    else if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_TransactionReport) // Transaction Report
    {
      this.transactionReport();
      return;
    } else if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_VoidedTransactionReport) // Voided Transaction Report
    {
      this.voidedTransactionReport();
      return;
    } else if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_LedgerTransactionReport) // Ledger Transaction Report
    {
      this.ledgerTransactionReport();
      return;
    } else if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_Financial_AuditReport) // Financial Audit Report
    {
      this.financialAuditReport();
      return;
    } else if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_Credit_Balance) // Financial Audit Report
    {
      this.creditBalanceReport();
      return;
    } else if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_CreditCardReceiptReport) // Credit Card Receipt  Report
    {
      this.creditCardReceiptReport();
      return;
    } else if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_RecallReport) // Recall Report
    {
      this.recallReport();
      return;
    }
    else if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_ProceduresWithNoClaims) // Procedures With No Claims Report
    {
      this.proceduresWithNoClaimsReport();
      return;
    }
    else if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_ClaimsNoSent) // Claims No Sent Report
    {
      this.claimsNoSentReport();
      return;
    }
    else if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_OutstandingClaims) // Outstanding Claims Report
    {
      this.OutstandingClaimsReport();
      return;
    }
    else if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_ReferringAnalysis) // Referring Analysis Report
    {
      this.referringAnalysisReport();
      return;
    }
    else if (this.activeReport.ReportID.toUpperCase() === ReportIDEnum.reportID_PatientsNeedAppointment) {
      this.patientsNeedAppointmentReport();
      return;
    }
  }


  runLetter(event: MatCheckboxChange) {
    this.isLetterSubstitute = event.checked;
  }

  arcClaimParams() {
    this.AddParameterToReport('ARClaimID', this.reportStartUpObject.reportGlobalParameters.ARClaimID, DataTypeEnum.String);
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    if (this.reportStartUpObject.reportGlobalParameters.ReportADAExtraParams !== undefined) {
      if (this.reportStartUpObject.reportGlobalParameters.ReportADAExtraParams.diagCodeListQualifierA !== undefined &&
        this.reportStartUpObject.reportGlobalParameters.ReportADAExtraParams.diagCodeListQualifierA !== '') {
        this.AddParameterToReport('diagCodeListQualifierA', this.reportStartUpObject.reportGlobalParameters.ReportADAExtraParams.diagCodeListQualifierA, DataTypeEnum.String);
      }
      if (this.reportStartUpObject.reportGlobalParameters.ReportADAExtraParams.diagCodeListQualifierB !== undefined &&
        this.reportStartUpObject.reportGlobalParameters.ReportADAExtraParams.diagCodeListQualifierB !== '') {
        this.AddParameterToReport('diagCodeListQualifierB', this.reportStartUpObject.reportGlobalParameters.ReportADAExtraParams.diagCodeListQualifierB, DataTypeEnum.String);
      }
      if (this.reportStartUpObject.reportGlobalParameters.ReportADAExtraParams.diagCodePrimA !== undefined &&
        this.reportStartUpObject.reportGlobalParameters.ReportADAExtraParams.diagCodePrimA !== '') {
        this.AddParameterToReport('diagCodePrimA', this.reportStartUpObject.reportGlobalParameters.ReportADAExtraParams.diagCodePrimA, DataTypeEnum.String);
      }
      if (this.reportStartUpObject.reportGlobalParameters.ReportADAExtraParams.diagCodePrimB !== undefined &&
        this.reportStartUpObject.reportGlobalParameters.ReportADAExtraParams.diagCodePrimB !== '') {
        this.AddParameterToReport('diagCodePrimB', this.reportStartUpObject.reportGlobalParameters.ReportADAExtraParams.diagCodePrimB, DataTypeEnum.String);
      }
      if (this.reportStartUpObject.reportGlobalParameters.ReportADAExtraParams.diagCodePrimC !== undefined &&
        this.reportStartUpObject.reportGlobalParameters.ReportADAExtraParams.diagCodePrimC !== '') {
        this.AddParameterToReport('diagCodePrimC', this.reportStartUpObject.reportGlobalParameters.ReportADAExtraParams.diagCodePrimC, DataTypeEnum.String);
      }
      if (this.reportStartUpObject.reportGlobalParameters.ReportADAExtraParams.diagCodePrimD !== undefined &&
        this.reportStartUpObject.reportGlobalParameters.ReportADAExtraParams.diagCodePrimD !== '') {
        this.AddParameterToReport('diagCodePrimD', this.reportStartUpObject.reportGlobalParameters.ReportADAExtraParams.diagCodePrimD, DataTypeEnum.String);
      }
      if (this.reportStartUpObject.reportGlobalParameters.ReportADAExtraParams.remarks !== undefined &&
        this.reportStartUpObject.reportGlobalParameters.ReportADAExtraParams.remarks !== '') {
        this.AddParameterToReport('remarks', this.reportStartUpObject.reportGlobalParameters.ReportADAExtraParams.remarks, DataTypeEnum.String);
      }
    }
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }

  allDoctorsParams() {
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.showParameters();
    this.getReportUrl();
  }


  PerioChartComparisonReportParams() {
    this.AddParameterToReport('PatientID', this.globals.currentPatientId.toUpperCase(), DataTypeEnum.String);
    this.AddParameterToReport('currentPerioChartID', this.reportStartUpObject.reportGlobalParameters.currentPerioChartID, DataTypeEnum.String);
    this.AddParameterToReport('oldPerioChartID', this.reportStartUpObject.reportGlobalParameters.oldPerioChartID, DataTypeEnum.String);
    this.AddParameterToReport('LOCID', this.reportStartUpObject.reportGlobalParameters.LOCID, DataTypeEnum.String);
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }

  PerioChartReportParams() {
    this.AddParameterToReport('PatientID', this.globals.currentPatientId.toUpperCase(), DataTypeEnum.String);
    this.AddParameterToReport('currentPerioChartID', this.reportStartUpObject.reportGlobalParameters.currentPerioChartID, DataTypeEnum.String);
    this.AddParameterToReport('LOCID', this.reportStartUpObject.reportGlobalParameters.LOCID, DataTypeEnum.String);
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }

  patientStatementParams() {
    let i = 0;
    this.reportPatientStatementFilter.sendFilterToParent();
    if (this.globals.currentPatientId === undefined || this.globals.currentPatientId === null) {
      this.snackBar.open('Please select Patient', 'TDOX', {
        duration: 3000,
        verticalPosition: 'top'
      });
      return;
    }
    if (this.reportPatientStatementFilter.reportPatientStatementFilterModel === undefined) {
      this.snackBar.open('Please select parameters', 'TDOX', {
        duration: 3000,
        verticalPosition: 'top'
      });
      return;
    }

    if (this.isLetterSubstitute) {
      // create WebId Record to send to  Letters Module
      const isProvider = this.reportPatientStatementFilter.reportPatientStatementFilterModel.isProvider ? '1' : '0';
      const isPractice = this.reportPatientStatementFilter.reportPatientStatementFilterModel.isPractice ? '1' : '0';
      const ProvidersId = this.reportPatientStatementFilter.reportPatientStatementFilterModel.ProvidersId ? this.reportPatientStatementFilter.reportPatientStatementFilterModel.ProvidersId.map(e => e.replace(/\s/g, '')).join(',') : '';
      const PracticeLocations = this.reportPatientStatementFilter.reportPatientStatementFilterModel.PracticeLocations ? this.reportPatientStatementFilter.reportPatientStatementFilterModel.PracticeLocations.map(e => e.replace(/\s/g, '')).join(',') : '';
      const initialDate = this.datePipe.transform(ConversionUtilities.getInitialDate(this.reportPatientStatementFilter.reportPatientStatementFilterModel.initialDate), 'yyyy/MM/dd HH:mm:ss', 'UTC');
      const endDate = this.datePipe.transform(ConversionUtilities.getEndDate(this.reportPatientStatementFilter.reportPatientStatementFilterModel.endDate), 'yyyy/MM/dd HH:mm:ss', 'UTC');
      let object = new ReportLetterSubstituteParameterModel();
      object.LetterSubstituteID = this.ReportsLetterSubstitute.LetterSubstitueID;
      object.sqlStatement = 'exec tdo.spPatientStatement_LedgerDetails @PatientID = \'' + this.globals.currentPatientId.toUpperCase() + '\'' +
        ', @isProvider = \'' + isProvider + '\'' +
        ', @isPractice = \'' + isPractice + '\'' +
        ', @ProviderDoctorList = \'' + ProvidersId + '\'' +
        ', @PracticeLocationsIdList = \'' + PracticeLocations + '\'' +
        ', @initialDate = \'' + initialDate + '\'' +
        ', @endDate = \'' + endDate + '\'';
      object.isParent = true;
      object.Order = 1;

      this.reportService.saveReportLetterSubstitutionParameter(object).pipe(
        concatMap((result) => {
          if (result) {
            object = result;
            const childObject = new ReportLetterSubstituteParameterModel();
            childObject.WebID = result.WebID;
            childObject.LetterSubstituteID = this.ReportsLetterSubstitute.LetterSubstitueID;
            childObject.sqlStatement = 'EXEC tdo.spPatientStatement_PaymentDist @LedgerID';
            childObject.isParent = false;
            childObject.ParentID = result.ID;
            childObject.Order = 2;
            return this.reportService.saveReportLetterSubstitutionParameter(childObject);

        }}))
          .subscribe(data => {
            this.uiService.openLettersWindow({paramWebId: object.WebID});
          }
      );
    } else { // execute Report
      this.activeReport.cfgReportParameters = [];
      if (this.reportPatientStatementFilter.reportPatientStatementFilterModel.isProvider) {
        this.reportPatientStatementFilter.reportPatientStatementFilterModel.ProvidersId.forEach(provider => {
          this.AddParameterToReport('ProviderId' + i, provider, DataTypeEnum.String);
          i++;
        });
        this.AddParameterToReport('isProvider', true, DataTypeEnum.Boolean);
      }
      if (this.reportPatientStatementFilter.reportPatientStatementFilterModel.isPractice) {
        this.AddParameterToReport('PracticeId', this.reportPatientStatementFilter.reportPatientStatementFilterModel.PracticeId, DataTypeEnum.String);
        this.AddParameterToReport('isPractice', true, DataTypeEnum.Boolean);
        this.reportPatientStatementFilter.reportPatientStatementFilterModel.PracticeLocations.forEach(location => {
          this.AddParameterToReport('Location' + i, location, DataTypeEnum.String);
          i++;
        });
      }
      this.AddParameterToReport('initialDate', this.datePipe.transform(ConversionUtilities.getInitialDate(this.reportPatientStatementFilter.reportPatientStatementFilterModel.initialDate), 'yyyy/MM/dd HH:mm:ss', 'UTC'), DataTypeEnum.String);
      this.AddParameterToReport('endDate', this.datePipe.transform(ConversionUtilities.getEndDate(this.reportPatientStatementFilter.reportPatientStatementFilterModel.endDate), 'yyyy/MM/dd HH:mm:ss', 'UTC'), DataTypeEnum.String);
      this.AddParameterToReport('PatientID', this.globals.currentPatientId.toUpperCase(), DataTypeEnum.String);
      this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
      this.AddParameterToReport('StatementNotes', this.reportPatientStatementFilter.reportPatientStatementFilterModel.statementNote, DataTypeEnum.String);
      this.AddParameterToReport('CurrentLOCID', this.globals.LOCID, DataTypeEnum.String);
      this.hasDevReportParam = false;
      this.showParameters();
      this.getReportUrl();
    }
  }

  listOfAppointmentsParams() {
    let i = 0;
    this.reportListOfAppointmentsFilter.sendFilterToParent();
    if (this.globals.currentPatientId === undefined || this.globals.currentPatientId === null) {
      this.snackBar.open('Please select Patient', 'TDOX', {
        duration: 3000,
        verticalPosition: 'top'
      });
      return;
    }
    if (this.reportListOfAppointmentsFilter.reportListOfAppointmentsModel === undefined) {
      this.snackBar.open('Please select parameters', 'TDOX', {
        duration: 3000,
        verticalPosition: 'top'
      });
      return;
    }
    if (this.isLetterSubstitute) {
      // create WebId Record to send to  Letters Module
      const isProvider = this.reportListOfAppointmentsFilter.reportListOfAppointmentsModel.isProvider ? '1' : '0';
      const isPractice = this.reportListOfAppointmentsFilter.reportListOfAppointmentsModel.isPractice ? '1' : '0';
      const ProvidersId = this.reportListOfAppointmentsFilter.reportListOfAppointmentsModel.ProvidersId ? this.reportListOfAppointmentsFilter.reportListOfAppointmentsModel.ProvidersId.map(e => e.replace(/\s/g, '')).join(',') : '';
      const PracticeLocations = this.reportListOfAppointmentsFilter.reportListOfAppointmentsModel.PracticeLocations ? this.reportListOfAppointmentsFilter.reportListOfAppointmentsModel.PracticeLocations.map(e => e.replace(/\s/g, '')).join(',') : '';
      const initialDate = this.datePipe.transform(ConversionUtilities.getInitialDate(this.reportListOfAppointmentsFilter.reportListOfAppointmentsModel.initialDate), 'yyyy/MM/dd HH:mm:ss', 'UTC');
      const endDate = this.datePipe.transform(ConversionUtilities.getEndDate(this.reportListOfAppointmentsFilter.reportListOfAppointmentsModel.endDate), 'yyyy/MM/dd HH:mm:ss', 'UTC');
      let object = new ReportLetterSubstituteParameterModel();
      object.LetterSubstituteID = this.ReportsLetterSubstitute.LetterSubstitueID;
      object.sqlStatement = 'exec TDO.spListOfAppointments_Report @PatientID = \'' + this.globals.currentPatientId.toUpperCase() + '\'' +
        ', @isProvider = \'' + isProvider + '\'' +
        ', @isPractice = \'' + isPractice + '\'' +
        ', @ProvidersIdList = \'' + ProvidersId + '\'' +
        ', @LocationsIdList = \'' + PracticeLocations + '\'' +
        ', @initialDate = \'' + initialDate + '\'' +
        ', @endDate = \'' + endDate + '\'';
      object.isParent = false;
      object.Order = 0;

      this.reportService.saveReportLetterSubstitutionParameter(object).subscribe(result => {
        if (result) {
          object = result;
          this.uiService.openLettersWindow({ paramWebId : object.WebID});
        }
      });
    } else {
      this.activeReport.cfgReportParameters = [];
      if (this.reportListOfAppointmentsFilter.reportListOfAppointmentsModel.isProvider) {
        this.reportListOfAppointmentsFilter.reportListOfAppointmentsModel.ProvidersId.forEach(provider => {
          this.AddParameterToReport('ProviderId' + i, provider, DataTypeEnum.String);
          i++;
        });
        this.AddParameterToReport('isProvider', true, DataTypeEnum.Boolean);
      }
      if (this.reportListOfAppointmentsFilter.reportListOfAppointmentsModel.isPractice) {
        this.AddParameterToReport('PracticeId', this.reportListOfAppointmentsFilter.reportListOfAppointmentsModel.PracticeId, DataTypeEnum.String);
        this.AddParameterToReport('isPractice', true, DataTypeEnum.Boolean);
        this.reportListOfAppointmentsFilter.reportListOfAppointmentsModel.PracticeLocations.forEach(location => {
          this.AddParameterToReport('Location' + i, location, DataTypeEnum.String);
          i++;
        });
      }
      this.AddParameterToReport('initialDate', this.datePipe.transform(ConversionUtilities.getInitialDate(this.reportListOfAppointmentsFilter.reportListOfAppointmentsModel.initialDate), 'yyyy/MM/dd HH:mm:ss', 'UTC'), DataTypeEnum.String);
      this.AddParameterToReport('endDate', this.datePipe.transform(ConversionUtilities.getEndDate(this.reportListOfAppointmentsFilter.reportListOfAppointmentsModel.endDate), 'yyyy/MM/dd HH:mm:ss', 'UTC'), DataTypeEnum.String);
      this.AddParameterToReport('PatientID', this.globals.currentPatientId.toUpperCase(), DataTypeEnum.String);
      this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
      this.AddParameterToReport('CurrentLOCID', this.globals.LOCID, DataTypeEnum.String);
      this.hasDevReportParam = false;
      this.showParameters();
      this.getReportUrl();
    }
  }


  transactionReport() {
    let i = 0;
    this.reportTransactionFilter.sendFilterToParent();
    if (this.reportTransactionFilter.reportTransactionFilterModel === undefined) {

      this.snackBar.open('Please select parameters', 'TDOX', {
        duration: 3000,
        verticalPosition: 'top'
      });
      return;
    }
    this.activeReport.cfgReportParameters = [];

    if (this.reportTransactionFilter.reportTransactionFilterModel.isProvider) {
      this.reportTransactionFilter.reportTransactionFilterModel.ProvidersId.forEach(provider => {
        this.AddParameterToReport('ProviderId' + i, provider, DataTypeEnum.String);
        i++;
      });
      this.AddParameterToReport('isProvider', true, DataTypeEnum.Boolean);
    }
    if (this.reportTransactionFilter.reportTransactionFilterModel.isPractice) {
      this.AddParameterToReport('PracticeId', this.reportTransactionFilter.reportTransactionFilterModel.PracticeId, DataTypeEnum.String);
      this.AddParameterToReport('isPractice', true, DataTypeEnum.Boolean);
      this.reportTransactionFilter.reportTransactionFilterModel.PracticeLocations.forEach(location => {
        this.AddParameterToReport('Location' + i, location, DataTypeEnum.String);
        i++;
      });
    }
    this.AddParameterToReport('PracticeId', this.reportTransactionFilter.reportTransactionFilterModel.PracticeId, DataTypeEnum.String);
    this.AddParameterToReport('initialDate', this.datePipe.transform(ConversionUtilities.getInitialDate(this.reportTransactionFilter.reportTransactionFilterModel.initialDate), 'yyyy/MM/dd HH:mm:ss', 'UTC'), DataTypeEnum.String);
    this.AddParameterToReport('endDate', this.datePipe.transform(ConversionUtilities.getEndDate(this.reportTransactionFilter.reportTransactionFilterModel.endDate), 'yyyy/MM/dd HH:mm:ss', 'UTC'), DataTypeEnum.String);
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.AddParameterToReport('transactionType', this.reportTransactionFilter.reportTransactionFilterModel.transactionType, DataTypeEnum.String);
    this.AddParameterToReport('CurrentLOCID', this.globals.LOCID, DataTypeEnum.String);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }


  voidedTransactionReport() {
    let i = 0;
    this.reportVoidedTransactionFilter.sendFilterToParent();
    if (this.reportVoidedTransactionFilter.reportVoidedTransactionFilterModel === undefined) {

      this.snackBar.open('Please select parameters', 'TDOX', {
        duration: 3000,
        verticalPosition: 'top'
      });
      return;
    }
    this.activeReport.cfgReportParameters = [];

    if (this.reportVoidedTransactionFilter.reportVoidedTransactionFilterModel.isProvider) {
      this.reportVoidedTransactionFilter.reportVoidedTransactionFilterModel.ProvidersId.forEach(provider => {
        this.AddParameterToReport('ProviderId' + i, provider, DataTypeEnum.String);
        i++;
      });
      this.AddParameterToReport('isProvider', true, DataTypeEnum.Boolean);
    }

    if (this.reportVoidedTransactionFilter.reportVoidedTransactionFilterModel.isPractice) {
      this.AddParameterToReport('PracticeId', this.reportVoidedTransactionFilter.reportVoidedTransactionFilterModel.PracticeId, DataTypeEnum.String);
      this.AddParameterToReport('isPractice', true, DataTypeEnum.Boolean);
      this.reportVoidedTransactionFilter.reportVoidedTransactionFilterModel.PracticeLocations.forEach(location => {
        this.AddParameterToReport('Location' + i, location, DataTypeEnum.String);
        i++;
      });
    }
    this.AddParameterToReport('initialDate', this.datePipe.transform(ConversionUtilities.getInitialDate(this.reportVoidedTransactionFilter.reportVoidedTransactionFilterModel.initialDate), 'yyyy/MM/dd HH:mm:ss', 'UTC'), DataTypeEnum.String);
    this.AddParameterToReport('endDate', this.datePipe.transform(ConversionUtilities.getEndDate(this.reportVoidedTransactionFilter.reportVoidedTransactionFilterModel.endDate), 'yyyy/MM/dd HH:mm:ss', 'UTC'), DataTypeEnum.String);
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.AddParameterToReport('isOrderByDateCharged', this.reportVoidedTransactionFilter.reportVoidedTransactionFilterModel.isOrderByDateCharged, DataTypeEnum.Boolean);
    this.AddParameterToReport('CurrentLOCID', this.globals.LOCID, DataTypeEnum.String);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }

  creditBalanceReport() {
    let i = 0;
    this.reportCreditBalanceFilter.sendFilterToParent();
    if (this.reportCreditBalanceFilter.reportCreditBalanceFilterModel === undefined) {
      this.snackBar.open('Please select parameters', 'TDOX', {
        duration: 3000,
        verticalPosition: 'top'
      });
      return;
    }
    this.activeReport.cfgReportParameters = [];

    if (this.reportCreditBalanceFilter.reportCreditBalanceFilterModel.isProvider) {
      this.reportCreditBalanceFilter.reportCreditBalanceFilterModel.ProvidersId.forEach(provider => {
        this.AddParameterToReport('ProviderId' + i, provider, DataTypeEnum.String);
        i++;
      });
      this.AddParameterToReport('isProvider', true, DataTypeEnum.Boolean);
    }
    if (this.reportCreditBalanceFilter.reportCreditBalanceFilterModel.isPractice) {
      this.AddParameterToReport('PracticeId', this.reportCreditBalanceFilter.reportCreditBalanceFilterModel.PracticeId, DataTypeEnum.String);
      this.AddParameterToReport('isPractice', true, DataTypeEnum.Boolean);
      this.reportCreditBalanceFilter.reportCreditBalanceFilterModel.PracticeLocations.forEach(location => {
        this.AddParameterToReport('Location' + i, location, DataTypeEnum.String);
        i++;
      });
    }
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.AddParameterToReport('CurrentLOCID', this.globals.LOCID, DataTypeEnum.String);
    this.hasDevReportParam = false;
    this.showParameters();
    if (this.isLetterSubstitute) {
      // create WebId Record to send in Letter
      const isProvider = this.reportCreditBalanceFilter.reportCreditBalanceFilterModel.isProvider ? '1' : '0';
      const isPractice = this.reportCreditBalanceFilter.reportCreditBalanceFilterModel.isPractice ? '1' : '0';
      const ProvidersId = this.reportCreditBalanceFilter.reportCreditBalanceFilterModel.ProvidersId ? this.reportCreditBalanceFilter.reportCreditBalanceFilterModel.ProvidersId.map(e => e.replace(/\s/g, '')).join(',') : '';
      const PracticeLocations = this.reportCreditBalanceFilter.reportCreditBalanceFilterModel.PracticeLocations ? this.reportCreditBalanceFilter.reportCreditBalanceFilterModel.PracticeLocations.map(e => e.replace(/\s/g, '')).join(',') : '';
      let object = new ReportLetterSubstituteParameterModel();
      object.LetterSubstituteID = this.ReportsLetterSubstitute.LetterSubstitueID;
      object.sqlStatement = 'exec tdo.spCreditBalance_Details  @isProvider = \'' + isProvider + '\'' +
        ', @isPractice = \'' + isPractice + '\'' +
        ', @ProviderDoctorList = \'' + ProvidersId + '\'' +
        ', @PracticeLocationsIdList = \'' + PracticeLocations + '\'';
      object.isParent = false;
      object.Order = 0;

      this.reportService.saveReportLetterSubstitutionParameter(object).subscribe(result => {
        if (result) {
          object = result;
          this.uiService.openLettersWindow({ paramWebId : object.WebID});

        }
      });
    } else {
      this.getReportUrl();
    }
  }

  recallReport() {
    let i = 0;
    this.reportRecallFilter.sendFilterToParent();
    if (this.reportRecallFilter.reportRecallFilterModel === undefined) {
      this.snackBar.open('Please select parameters', 'TDOX', {
        duration: 3000,
        verticalPosition: 'top'
      });
      return;
    }
    this.activeReport.cfgReportParameters = [];

    if (this.reportRecallFilter.reportRecallFilterModel.isProvider) {
      this.reportRecallFilter.reportRecallFilterModel.ProvidersId.forEach(provider => {
        this.AddParameterToReport('ProviderId' + i, provider, DataTypeEnum.String);
        i++;
      });
      this.AddParameterToReport('isProvider', true, DataTypeEnum.Boolean);
    }
    if (this.reportRecallFilter.reportRecallFilterModel.isPractice) {
      this.AddParameterToReport('PracticeId', this.reportRecallFilter.reportRecallFilterModel.PracticeId, DataTypeEnum.String);
      this.AddParameterToReport('isPractice', true, DataTypeEnum.Boolean);
      this.reportRecallFilter.reportRecallFilterModel.PracticeLocations.forEach(location => {
        this.AddParameterToReport('Location' + i, location, DataTypeEnum.String);
        i++;
      });
    }
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.AddParameterToReport('CurrentLOCID', this.globals.LOCID, DataTypeEnum.String);
    this.AddParameterToReport('initialDate', this.datePipe.transform(ConversionUtilities.getInitialDate(this.reportRecallFilter.reportRecallFilterModel.initialDate), 'yyyy/MM/dd HH:mm:ss', 'UTC'), DataTypeEnum.String);
    this.AddParameterToReport('endDate', this.datePipe.transform(ConversionUtilities.getEndDate(this.reportRecallFilter.reportRecallFilterModel.endDate), 'yyyy/MM/dd HH:mm:ss', 'UTC'), DataTypeEnum.String);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }

  creditCardReceiptReport() {
    let i = 0;
    this.reportCreditCardReceiptFilter.sendFilterToParent();
    if (this.reportCreditCardReceiptFilter.reportCreditCardReceiptFilterModel === undefined) {
      this.snackBar.open('Please select parameters', 'TDOX', {
        duration: 3000,
        verticalPosition: 'top'
      });
      return;
    }
    
    this.activeReport.cfgReportParameters = [];
    this.AddParameterToReport('PaymentID', this.reportCreditCardReceiptFilter.reportCreditCardReceiptFilterModel.PaymentId, DataTypeEnum.String);
    this.AddParameterToReport('LedgerID', this.reportCreditCardReceiptFilter.reportCreditCardReceiptFilterModel.LedgerId, DataTypeEnum.String);
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.AddParameterToReport('TDOCID', localStorage.getItem('TDOCID'), DataTypeEnum.String);
    this.AddParameterToReport('LOCID', this.globals.LOCID, DataTypeEnum.String);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }

  ledgerTransactionReport() {
    let i = 0;
    this.reportLedgerTransactionFilter.sendFilterToParent();
    if (this.reportLedgerTransactionFilter.reportLedgerTransactionFilterModel === undefined) {
      this.snackBar.open('Please select parameters', 'TDOX', {
        duration: 3000,
        verticalPosition: 'top'
      });
      return;
    }
    this.activeReport.cfgReportParameters = [];
    if (this.reportLedgerTransactionFilter.reportLedgerTransactionFilterModel.isProvider) {
      this.reportLedgerTransactionFilter.reportLedgerTransactionFilterModel.ProvidersId.forEach(provider => {
        this.AddParameterToReport('ProviderId' + i, provider, DataTypeEnum.String);
        i++;
      });
      this.AddParameterToReport('isProvider', true, DataTypeEnum.Boolean);
    }
    if (this.reportLedgerTransactionFilter.reportLedgerTransactionFilterModel.isPractice) {
      this.AddParameterToReport('PracticeId', this.reportLedgerTransactionFilter.reportLedgerTransactionFilterModel.PracticeId, DataTypeEnum.String);
      this.AddParameterToReport('isPractice', true, DataTypeEnum.Boolean);
      this.reportLedgerTransactionFilter.reportLedgerTransactionFilterModel.PracticeLocations.forEach(location => {
        this.AddParameterToReport('Location' + i, location, DataTypeEnum.String);
        i++;
      });
    }
    this.AddParameterToReport('PracticeId', this.reportLedgerTransactionFilter.reportLedgerTransactionFilterModel.PracticeId, DataTypeEnum.String);
    this.AddParameterToReport('initialDate', this.datePipe.transform(ConversionUtilities.getInitialDate(this.reportLedgerTransactionFilter.reportLedgerTransactionFilterModel.initialDate), 'yyyy/MM/dd HH:mm:ss'), DataTypeEnum.String);
    this.AddParameterToReport('endDate', this.datePipe.transform(ConversionUtilities.getEndDate(this.reportLedgerTransactionFilter.reportLedgerTransactionFilterModel.endDate), 'yyyy/MM/dd HH:mm:ss'), DataTypeEnum.String);
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.AddParameterToReport('showProductionReport', this.reportLedgerTransactionFilter.reportLedgerTransactionFilterModel.showProductionReport, DataTypeEnum.Boolean);
    this.AddParameterToReport('showReceiptReport', this.reportLedgerTransactionFilter.reportLedgerTransactionFilterModel.showReceiptReport, DataTypeEnum.Boolean);
    this.AddParameterToReport('showActivityReport', this.reportLedgerTransactionFilter.reportLedgerTransactionFilterModel.showActivityReport, DataTypeEnum.Boolean);
    this.AddParameterToReport('showBankDepositsReport', this.reportLedgerTransactionFilter.reportLedgerTransactionFilterModel.showBankDepositsReport, DataTypeEnum.Boolean);
    this.AddParameterToReport('showTransactionsReport', this.reportLedgerTransactionFilter.reportLedgerTransactionFilterModel.showTransactionsReport, DataTypeEnum.Boolean);

    this.AddParameterToReport('isNewPage', this.reportLedgerTransactionFilter.reportLedgerTransactionFilterModel.isNewPage, DataTypeEnum.Boolean);
    this.AddParameterToReport('isActivityGroupByDoctor', this.reportLedgerTransactionFilter.reportLedgerTransactionFilterModel.isActivityGroupByDoctor, DataTypeEnum.Boolean);
    this.AddParameterToReport('showTransactionCash', this.reportLedgerTransactionFilter.reportLedgerTransactionFilterModel.showTransactionCash, DataTypeEnum.Boolean);
    this.AddParameterToReport('showTransactionCreditCard', this.reportLedgerTransactionFilter.reportLedgerTransactionFilterModel.showTransactionCreditCard, DataTypeEnum.Boolean);
    this.AddParameterToReport('showTransactionDebit', this.reportLedgerTransactionFilter.reportLedgerTransactionFilterModel.showTransactionDebit, DataTypeEnum.Boolean);
    this.AddParameterToReport('showTransactionOther', this.reportLedgerTransactionFilter.reportLedgerTransactionFilterModel.showTransactionOther, DataTypeEnum.Boolean);
    this.AddParameterToReport('CurrentLOCID', this.globals.LOCID, DataTypeEnum.String);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }

  financialAuditReport() {
    this.reportFinancialAuditFilter.sendFilterToParent();
    if (this.reportFinancialAuditFilter.reportFinancialAuditFilterModel === undefined) {

      this.snackBar.open('Please select parameters', 'TDOX', {
        duration: 3000,
        verticalPosition: 'top'
      });
      return;
    }
    this.activeReport.cfgReportParameters = [];
    this.AddParameterToReport('initialDate', this.datePipe.transform(ConversionUtilities.getInitialDate(this.reportFinancialAuditFilter.reportFinancialAuditFilterModel.initialDate), 'yyyy/MM/dd HH:mm:ss', 'UTC'), DataTypeEnum.String);
    this.AddParameterToReport('endDate', this.datePipe.transform(ConversionUtilities.getEndDate(this.reportFinancialAuditFilter.reportFinancialAuditFilterModel.endDate), 'yyyy/MM/dd HH:mm:ss', 'UTC'), DataTypeEnum.String);
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.AddParameterToReport('PracticeId', this.reportFinancialAuditFilter.reportFinancialAuditFilterModel.PracticeId, DataTypeEnum.String);
    this.AddParameterToReport('CurrentLOCID', this.globals.LOCID, DataTypeEnum.String);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }


  financialSummaryParams() {
    let i = 0;
    this.reportFinancialSummaryFilter.sendFilterToParent();
    if (this.reportFinancialSummaryFilter.reportFinancialSummaryFilterModel === undefined) {
      this.snackBar.open('Please select parameters', 'TDOX', {
        duration: 3000,
        verticalPosition: 'top'
      });
      return;
    }
    this.activeReport.cfgReportParameters = [];

    if (this.reportFinancialSummaryFilter.reportFinancialSummaryFilterModel.isProvider) {
      this.reportFinancialSummaryFilter.reportFinancialSummaryFilterModel.ProvidersId.forEach(provider => {
        this.AddParameterToReport('ProviderId' + i, provider, DataTypeEnum.String);
        i++;
      });
      this.AddParameterToReport('isProvider', true, DataTypeEnum.Boolean);
    }
    if (this.reportFinancialSummaryFilter.reportFinancialSummaryFilterModel.isPractice) {
      this.AddParameterToReport('PracticeId', this.reportFinancialSummaryFilter.reportFinancialSummaryFilterModel.PracticeId, DataTypeEnum.String);
      this.AddParameterToReport('isPractice', true, DataTypeEnum.Boolean);
      this.reportFinancialSummaryFilter.reportFinancialSummaryFilterModel.PracticeLocations.forEach(location => {
        this.AddParameterToReport('Location' + i, location, DataTypeEnum.String);
        i++;
      });
    }
    this.AddParameterToReport('initialDate', this.datePipe.transform(ConversionUtilities.getInitialDate(this.reportFinancialSummaryFilter.reportFinancialSummaryFilterModel.initialDate), 'yyyy/MM/dd HH:mm:ss', 'UTC'), DataTypeEnum.String);
    this.AddParameterToReport('endDate', this.datePipe.transform(ConversionUtilities.getEndDate(this.reportFinancialSummaryFilter.reportFinancialSummaryFilterModel.endDate), 'yyyy/MM/dd HH:mm:ss', 'UTC'), DataTypeEnum.String);
    this.AddParameterToReport('isCurrentMonthParams', this.reportFinancialSummaryFilter.isCurrentMonth, DataTypeEnum.Boolean);
    this.AddParameterToReport('PatientID', this.globals.currentPatientId.toUpperCase(), DataTypeEnum.String);
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.AddParameterToReport('CurrentLOCID', this.globals.LOCID, DataTypeEnum.String);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }

  proceduresWithNoClaimsReport(){
    let i = 0;
    this.reportProcedureWithNoClaimsFilter.sendFilterToParent();
    if (this.reportProcedureWithNoClaimsFilter.reportProceduresWithNoClaimsModel === undefined) {
      this.snackBar.open('Please select parameters', 'TDOX', {
        duration: 3000,
        verticalPosition: 'top'
      });
      return;
    }
    this.activeReport.cfgReportParameters = [];

    if (this.reportProcedureWithNoClaimsFilter.reportProceduresWithNoClaimsModel.isProvider) {
      this.reportProcedureWithNoClaimsFilter.reportProceduresWithNoClaimsModel.ProvidersId.forEach(provider => {
        this.AddParameterToReport('ProviderId' + i, provider, DataTypeEnum.String);
        i++;
      });
      this.AddParameterToReport('isProvider', true, DataTypeEnum.Boolean);
    }
    if (this.reportProcedureWithNoClaimsFilter.reportProceduresWithNoClaimsModel.isPractice) {
      this.AddParameterToReport('PracticeId', this.reportProcedureWithNoClaimsFilter.reportProceduresWithNoClaimsModel.PracticeId, DataTypeEnum.String);
      this.AddParameterToReport('isPractice', true, DataTypeEnum.Boolean);
      this.reportProcedureWithNoClaimsFilter.reportProceduresWithNoClaimsModel.PracticeLocations.forEach(location => {
        this.AddParameterToReport('Location' + i, location, DataTypeEnum.String);
        i++;
      });
    }
    this.AddParameterToReport('initialDate', this.datePipe.transform(ConversionUtilities.getInitialDate(this.reportProcedureWithNoClaimsFilter.reportProceduresWithNoClaimsModel.initialDate), 'yyyy/MM/dd HH:mm:ss'), DataTypeEnum.String);
    this.AddParameterToReport('endDate', this.datePipe.transform(ConversionUtilities.getEndDate(this.reportProcedureWithNoClaimsFilter.reportProceduresWithNoClaimsModel.endDate), 'yyyy/MM/dd HH:mm:ss'), DataTypeEnum.String);
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.AddParameterToReport('CurrentLOCID', this.globals.LOCID, DataTypeEnum.String);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }

  claimsNoSentReport(){
    let i = 0;
    this.reportClaimsNotSentFilter.sendFilterToParent();
    if (this.reportClaimsNotSentFilter.reportClaimsNotSentModel === undefined) {
      this.snackBar.open('Please select parameters', 'TDOX', {
        duration: 3000,
        verticalPosition: 'top'
      });
      return;
    }
    this.activeReport.cfgReportParameters = [];

    if (this.reportClaimsNotSentFilter.reportClaimsNotSentModel.isProvider) {
      this.reportClaimsNotSentFilter.reportClaimsNotSentModel.ProvidersId.forEach(provider => {
        this.AddParameterToReport('ProviderId' + i, provider, DataTypeEnum.String);
        i++;
      });
      this.AddParameterToReport('isProvider', true, DataTypeEnum.Boolean);
    }
    if (this.reportClaimsNotSentFilter.reportClaimsNotSentModel.isPractice) {
      this.AddParameterToReport('PracticeId', this.reportClaimsNotSentFilter.reportClaimsNotSentModel.PracticeId, DataTypeEnum.String);
      this.AddParameterToReport('isPractice', true, DataTypeEnum.Boolean);
      this.reportClaimsNotSentFilter.reportClaimsNotSentModel.PracticeLocations.forEach(location => {
        this.AddParameterToReport('Location' + i, location, DataTypeEnum.String);
        i++;
      });
    }
    this.AddParameterToReport('initialDate', this.datePipe.transform(ConversionUtilities.getInitialDate(this.reportClaimsNotSentFilter.reportClaimsNotSentModel.initialDate), 'yyyy/MM/dd HH:mm:ss'), DataTypeEnum.String);
    this.AddParameterToReport('endDate', this.datePipe.transform(ConversionUtilities.getEndDate(this.reportClaimsNotSentFilter.reportClaimsNotSentModel.endDate), 'yyyy/MM/dd HH:mm:ss'), DataTypeEnum.String);
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.AddParameterToReport('CurrentLOCID', this.globals.LOCID, DataTypeEnum.String);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }

  OutstandingClaimsReport() { 
    let i = 0;
    this.reportOutstandingClaimsFilter.sendFilterToParent();
    if (this.reportOutstandingClaimsFilter.reportOutstandingClaimsModel === undefined) {
      this.snackBar.open('Please select parameters', 'TDOX', {
        duration: 3000,
        verticalPosition: 'top'
      });
      return;
    }
    this.activeReport.cfgReportParameters = [];

    if (this.reportOutstandingClaimsFilter.reportOutstandingClaimsModel.isEClaims) {
            this.AddParameterToReport('isEClaims', true, DataTypeEnum.Boolean);
    }
    if (this.reportOutstandingClaimsFilter.reportOutstandingClaimsModel.isADAForm) {
      this.AddParameterToReport('isADAForm', true, DataTypeEnum.Boolean);
    }
    if (this.reportOutstandingClaimsFilter.reportOutstandingClaimsModel.Over30) {
      this.AddParameterToReport('Over30', true, DataTypeEnum.Boolean);
    }
    if (this.reportOutstandingClaimsFilter.reportOutstandingClaimsModel.Over60) {
      this.AddParameterToReport('Over60', true, DataTypeEnum.Boolean);
    }
    if (this.reportOutstandingClaimsFilter.reportOutstandingClaimsModel.Over90) {
      this.AddParameterToReport('Over90', true, DataTypeEnum.Boolean);
    }

    if (this.reportOutstandingClaimsFilter.reportOutstandingClaimsModel.isProvider) {
      this.reportOutstandingClaimsFilter.reportOutstandingClaimsModel.ProvidersId.forEach(provider => {
        this.AddParameterToReport('ProviderId' + i, provider, DataTypeEnum.String);
        i++;
      });
      this.AddParameterToReport('isProvider', true, DataTypeEnum.Boolean);
    }
    if (this.reportOutstandingClaimsFilter.reportOutstandingClaimsModel.isPractice) {
      this.AddParameterToReport('PracticeId', this.reportOutstandingClaimsFilter.reportOutstandingClaimsModel.PracticeId, DataTypeEnum.String);
      this.AddParameterToReport('isPractice', true, DataTypeEnum.Boolean);
      this.reportOutstandingClaimsFilter.reportOutstandingClaimsModel.PracticeLocations.forEach(location => {
        this.AddParameterToReport('Location' + i, location, DataTypeEnum.String);
        i++;
      });
    }
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.AddParameterToReport('CurrentLOCID', this.globals.LOCID, DataTypeEnum.String);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }

  referringAnalysisReport() {
    let i = 0;
    this.reportReferringAnalysisFilter.sendFilterToParent();
    if (this.reportReferringAnalysisFilter.reportReferringAnalysisModel === undefined) {
      this.snackBar.open('Please select parameters', 'TDOX', {
        duration: 3000,
        verticalPosition: 'top' 
      });
      return;
    }
    this.activeReport.cfgReportParameters = [];

    if (this.reportReferringAnalysisFilter.reportReferringAnalysisModel.isProvider) {
      this.reportReferringAnalysisFilter.reportReferringAnalysisModel.ProvidersId.forEach(provider => {
        this.AddParameterToReport('ProviderId' + i, provider, DataTypeEnum.String);
        i++;
      });
    }

    if (this.reportReferringAnalysisFilter.reportReferringAnalysisModel.isPractice) {
      this.AddParameterToReport('isPractice', true, DataTypeEnum.Boolean);
      this.reportReferringAnalysisFilter.reportReferringAnalysisModel.PracticeLocations.forEach(location => {
        this.AddParameterToReport('Location' + i, location, DataTypeEnum.String);
        i++;
      });
    }   

    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.AddParameterToReport('CurrentLOCID', this.globals.LOCID, DataTypeEnum.String);
    this.AddParameterToReport('initialDate', this.datePipe.transform(ConversionUtilities.getInitialDate(this.reportReferringAnalysisFilter.reportReferringAnalysisModel.initialDate), 'yyyy/MM/dd HH:mm:ss', 'UTC'), DataTypeEnum.String);
    this.AddParameterToReport('endDate', this.datePipe.transform(ConversionUtilities.getEndDate(this.reportReferringAnalysisFilter.reportReferringAnalysisModel.endDate), 'yyyy/MM/dd HH:mm:ss', 'UTC'), DataTypeEnum.String);
    this.AddParameterToReport('isAll', this.reportReferringAnalysisFilter.reportReferringAnalysisModel.isAll, DataTypeEnum.Boolean);
    this.AddParameterToReport('IncludePerDoctor', this.reportReferringAnalysisFilter.reportReferringAnalysisModel.IncludePerDoctor, DataTypeEnum.Boolean);
    this.AddParameterToReport('IncludePerCode', this.reportReferringAnalysisFilter.reportReferringAnalysisModel.IncludePerCode, DataTypeEnum.Boolean);
    this.AddParameterToReport('IncludeBreakDown', this.reportReferringAnalysisFilter.reportReferringAnalysisModel.IncludeBreakDown, DataTypeEnum.Boolean);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }

  patientsNeedAppointmentReport() {
    let i = 0;
    this.reportPatientsNeedAppointmentFilter.sendFilterToParent();
    if (this.reportPatientsNeedAppointmentFilter.reportPatientsNeedAppointmentModel === undefined) {
      this.snackBar.open('Please select parameters', 'TDOX', {
        duration: 3000,
        verticalPosition: 'top'
      });
      return;
    }
      this.reportPatientsNeedAppointmentFilter.reportPatientsNeedAppointmentModel.PracticeLocations.forEach(location => {
        this.AddParameterToReport('Location' + i, location, DataTypeEnum.String);
        i++;
      });
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.AddParameterToReport('CurrentLOCID', this.globals.LOCID, DataTypeEnum.String);
    this.AddParameterToReport('initialDate', this.datePipe.transform(ConversionUtilities.getInitialDate(this.reportPatientsNeedAppointmentFilter.reportPatientsNeedAppointmentModel.initialDate), 'yyyy/MM/dd HH:mm:ss'), DataTypeEnum.String);
    this.AddParameterToReport('endDate', this.datePipe.transform(ConversionUtilities.getEndDate(this.reportPatientsNeedAppointmentFilter.reportPatientsNeedAppointmentModel.endDate), 'yyyy/MM/dd HH:mm:ss'), DataTypeEnum.String);
    this.AddParameterToReport('isNewOnly', this.reportPatientsNeedAppointmentFilter.reportPatientsNeedAppointmentModel.isNewOnly, DataTypeEnum.Boolean);
    this.AddParameterToReport('TDOCID', localStorage.getItem('TDOCID'), DataTypeEnum.String);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }

  financialSnapshotBreakDownParams() {
    this.reportFinancialSnapshotBreakDownFilter.sendFilterToParent();
    if (this.reportFinancialSnapshotFilters === undefined) {
      this.snackBar.open('Please select parameters', 'TDOX', {
        duration: 3000,
        verticalPosition: 'top'
      });
      return;
    }

    let i = 0;
    this.activeReport.cfgReportParameters = [];
    //this.AddParameterToReport('ProviderId', this.reportFinancialSnapshotFilters.ProviderId, DataTypeEnum.String);
    this.reportFinancialSnapshotFilters.ProvidersId.forEach(provider => {
      this.AddParameterToReport('ProviderId' + i, provider, DataTypeEnum.String);
      i++;
    });
    this.AddParameterToReport('SnapshotTypeId', this.reportFinancialSnapshotFilters.TypeId, DataTypeEnum.String);
    this.AddParameterToReport('isCurrentMonth', this.reportFinancialSnapshotFilters.isCurrentMonth, DataTypeEnum.Boolean);
    this.AddParameterToReport('initialDate', this.datePipe.transform(ConversionUtilities.getInitialDate(this.reportFinancialSnapshotFilters.initialDate), 'yyyy/MM/dd HH:mm:ss'), DataTypeEnum.String);
    this.AddParameterToReport('endDate', this.datePipe.transform(ConversionUtilities.getEndDate(this.reportFinancialSnapshotFilters.endDate), 'yyyy/MM/dd HH:mm:ss'), DataTypeEnum.String);
    this.AddParameterToReport('OrderBy', this.reportFinancialSnapshotFilters.OrderBy, DataTypeEnum.String);
    this.AddParameterToReport('isAsc', this.reportFinancialSnapshotFilters.isAsc, DataTypeEnum.Boolean);
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.AddParameterToReport('CurrentLOCID', this.globals.LOCID, DataTypeEnum.String);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }

  agingAnalysisParams() {
    let i = 0;
    this.reportAgingFilter.sendFilterToParent();
    if (this.reportAgingFilters === undefined) {
      this.snackBar.open('Please select parameters', 'TDOX', {
        duration: 3000,
        verticalPosition: 'top'
      });
      return;
    }
    this.activeReport.cfgReportParameters = [];
    if (this.reportAgingFilters.isProvider) {
      this.reportAgingFilters.ProvidersId.forEach(provider => {
        this.AddParameterToReport('ProviderId' + i, provider, DataTypeEnum.String);
        i++;
      });
      this.AddParameterToReport('isProvider', true, DataTypeEnum.Boolean);
    }
    if (this.reportAgingFilters.isPractice) {
      this.AddParameterToReport('PracticeId', this.reportAgingFilters.PracticeId, DataTypeEnum.String);
      this.AddParameterToReport('isPractice', true, DataTypeEnum.Boolean);
      this.reportAgingFilters.PracticeLocations.forEach(location => {
        this.AddParameterToReport('Location' + i, location, DataTypeEnum.String);
        i++;
      });
    }
    this.AddParameterToReport('IsTrueBalance', this.reportAgingFilters.IsTrueBalance, DataTypeEnum.Boolean);
    this.AddParameterToReport('IsAllPeriods', this.reportAgingFilters.IsAllPeriods, DataTypeEnum.Boolean);
    this.AddParameterToReport('isCurrent', this.reportAgingFilters.isCurrent, DataTypeEnum.Boolean);
    this.AddParameterToReport('is30Day', this.reportAgingFilters.is30Day, DataTypeEnum.Boolean);
    this.AddParameterToReport('is60Day', this.reportAgingFilters.is60Day, DataTypeEnum.Boolean);
    this.AddParameterToReport('is90Day', this.reportAgingFilters.is90Day, DataTypeEnum.Boolean);
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.AddParameterToReport('CurrentLOCID', this.globals.LOCID, DataTypeEnum.String);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }

  // DevExpress Report
  financialSnapshotDevExpressParams() {
    // let parameters: IParams;
    this.reportFinancialSnapshotBreakDownFilter.sendFilterToParent();
    if (this.reportFinancialSnapshotFilters === undefined) {
      this.snackBar.open('Please select parameters', 'TDOX', {
        duration: 3000,
        verticalPosition: 'top'
      });
      return;
    }


    this.activeReport.cfgReportParameters = [];
    this.AddParameterToReport('isProvider', this.reportFinancialSnapshotFilters.isProvider, DataTypeEnum.Boolean);
    // this.AddParameterToReport('ProviderId', this.reportFinancialSnapshotFilters.ProviderId, DataTypeEnum.String);
    this.AddParameterToReport('PracticeId', this.reportFinancialSnapshotFilters.PracticeId, DataTypeEnum.Integer);
    this.AddParameterToReport('SnapshotTypeId', this.reportFinancialSnapshotFilters.TypeId, DataTypeEnum.String);
    this.AddParameterToReport('isCurrentMonth', this.reportFinancialSnapshotFilters.isCurrentMonth, DataTypeEnum.Boolean);
    this.AddParameterToReport('initialDate', this.datePipe.transform(ConversionUtilities.getInitialDate(this.reportFinancialSnapshotFilters.initialDate), 'yyyy/MM/dd HH:mm:ss', 'UTC'), DataTypeEnum.String);
    this.AddParameterToReport('endDate', this.datePipe.transform(ConversionUtilities.getEndDate(this.reportFinancialSnapshotFilters.endDate), 'yyyy/MM/dd HH:mm:ss', 'UTC'), DataTypeEnum.String);
    this.AddParameterToReport('OrderBy', this.reportFinancialSnapshotFilters.OrderBy, DataTypeEnum.String);
    this.AddParameterToReport('isAsc', this.reportFinancialSnapshotFilters.isAsc, DataTypeEnum.Boolean);
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.AddParameterToReport('CurrentLOCID', this.globals.LOCID, DataTypeEnum.String);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }

  // HTML Report
  financialSnapshotParams() {
    let parameters: IParams;
    let i = 0;
    this.reportFinancialSnapshotFilter.sendFilterToParent();
    if (this.reportFinancialSnapshotFilter === undefined) {
      this.snackBar.open('Please select parameters', 'TDOX', {
        duration: 3000,
        verticalPosition: 'top'
      });
      return;
    }
    if (this.reportFinancialSnapshotFilter.isInteractiveReport) { // HTML Report
      // this.isSnapShotReport = true;
      this.isSnapshotDevExpress = false;

      parameters = {
        isProvider: this.reportFinancialSnapshotFilter.reportFinancialSnapshotFilterModel.isProvider,
        isPractice: this.reportFinancialSnapshotFilter.reportFinancialSnapshotFilterModel.isPractice,
        ProvidersId: this.reportFinancialSnapshotFilter.reportFinancialSnapshotFilterModel.ProvidersId,
        ProviderId: '',
        PracticeLocations: this.reportFinancialSnapshotFilter.reportFinancialSnapshotFilterModel.PracticeLocations,
        PracticeId: this.reportFinancialSnapshotFilter.reportFinancialSnapshotFilterModel.PracticeId,
        initialDate: this.datePipe.transform(ConversionUtilities.getInitialDate(this.reportFinancialSnapshotFilter.reportFinancialSnapshotFilterModel.initialDate), 'yyyy/MM/dd HH:mm:ss'),
        endDate: this.datePipe.transform(ConversionUtilities.getEndDate(this.reportFinancialSnapshotFilter.reportFinancialSnapshotFilterModel.endDate), 'yyyy/MM/dd HH:mm:ss'),
        isAsc: this.reportFinancialSnapshotFilter.reportFinancialSnapshotFilterModel.isAsc,
        showInactive: this.reportFinancialSnapshotFilter.reportFinancialSnapshotFilterModel.showInactive,
        reportName: 'Snapshot Report',
        dateRange: this.reportFinancialSnapshotFilter.reportFinancialSnapshotFilterModel.dateRange,
        CurrentLocation: this.globals.LOCID
      };
      this.ReportFinancialSnapshot.loadReport(parameters, false);
    } else {

      this.isSnapshotDevExpress = true;
      this.activeReport.cfgReportParameters = [];
      if (this.reportFinancialSnapshotFilter.reportFinancialSnapshotFilterModel.isProvider) {
        this.reportFinancialSnapshotFilter.reportFinancialSnapshotFilterModel.ProvidersId.forEach(provider => {
          this.AddParameterToReport('ProviderId' + i, provider, DataTypeEnum.String);
          i++;
        });
        this.AddParameterToReport('isProvider', true, DataTypeEnum.Boolean);
      }
      if (this.reportFinancialSnapshotFilter.reportFinancialSnapshotFilterModel.isPractice) {
        this.AddParameterToReport('PracticeId', this.reportFinancialSnapshotFilter.reportFinancialSnapshotFilterModel.PracticeId, DataTypeEnum.String);
        this.AddParameterToReport('isPractice', true, DataTypeEnum.Boolean);
        this.reportFinancialSnapshotFilter.reportFinancialSnapshotFilterModel.PracticeLocations.forEach(location => {
          this.AddParameterToReport('Location' + i, location, DataTypeEnum.String);
          i++;
        });
      }
      this.AddParameterToReport('showInactive', this.reportFinancialSnapshotFilter.reportFinancialSnapshotFilterModel.showInactive, DataTypeEnum.Boolean);
      this.AddParameterToReport('initialDate', this.datePipe.transform(ConversionUtilities.getInitialDate(this.reportFinancialSnapshotFilter.reportFinancialSnapshotFilterModel.initialDate), 'yyyy/MM/dd HH:mm:ss'), DataTypeEnum.String);
      this.AddParameterToReport('endDate', this.datePipe.transform(ConversionUtilities.getEndDate(this.reportFinancialSnapshotFilter.reportFinancialSnapshotFilterModel.endDate), 'yyyy/MM/dd HH:mm:ss'), DataTypeEnum.String);
      this.AddParameterToReport('OrderBy', this.reportFinancialSnapshotFilter.reportFinancialSnapshotFilterModel.OrderBy, DataTypeEnum.String);
      this.AddParameterToReport('isAsc', this.reportFinancialSnapshotFilter.reportFinancialSnapshotFilterModel.isAsc, DataTypeEnum.Boolean);
      this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
      this.AddParameterToReport('isDailySnapshot', false, DataTypeEnum.Boolean);
      this.AddParameterToReport('CurrentLOCID', this.globals.LOCID, DataTypeEnum.String);
      this.hasDevReportParam = false;
      this.showParameters();
      this.getReportUrl();
    }
  }

  // HTML Report
  financialDailySnapshotParams() {
    let parameters: IParams;
    let i = 0;
    this.reportFinancialSnapshotFilter.sendFilterToParent();
    if (this.reportFinancialSnapshotFilter === undefined) {
      this.snackBar.open('Please select parameters', 'TDOX', {
        duration: 3000,
        verticalPosition: 'top'
      });
      return;
    }
    if (this.reportFinancialSnapshotFilter.isInteractiveReport) { // HTML Report
      this.isSnapshotDevExpress = false;
      parameters = {
        isProvider: this.reportFinancialSnapshotFilter.reportFinancialSnapshotFilterModel.isProvider,
        isPractice: this.reportFinancialSnapshotFilter.reportFinancialSnapshotFilterModel.isPractice,
        ProvidersId: this.reportFinancialSnapshotFilter.reportFinancialSnapshotFilterModel.ProvidersId,
        ProviderId: '13',
        PracticeLocations: this.reportFinancialSnapshotFilter.reportFinancialSnapshotFilterModel.PracticeLocations,
        PracticeId: this.reportFinancialSnapshotFilter.reportFinancialSnapshotFilterModel.PracticeId,
        initialDate: this.datePipe.transform(ConversionUtilities.getInitialDate(new Date()), 'yyyy/MM/dd HH:mm:ss', 'UTC'),
        endDate: this.datePipe.transform(ConversionUtilities.getEndDate(new Date()), 'yyyy/MM/dd HH:mm:ss', 'UTC'),
        isAsc: this.reportFinancialSnapshotFilter.reportFinancialSnapshotFilterModel.isAsc,
        showInactive: this.reportFinancialSnapshotFilter.reportFinancialSnapshotFilterModel.showInactive,
        reportName: 'Daily Snapshot Report',
        dateRange: this.reportFinancialSnapshotFilter.reportFinancialSnapshotFilterModel.dateRange,
        CurrentLocation: this.globals.LOCID
      };
      this.ReportFinancialSnapshot.loadReport(parameters, true);
    } else {
      this.isSnapshotDevExpress = true;
      this.activeReport.cfgReportParameters = [];

      if (this.reportFinancialSnapshotFilter.reportFinancialSnapshotFilterModel.isProvider) {
        this.reportFinancialSnapshotFilter.reportFinancialSnapshotFilterModel.ProvidersId.forEach(provider => {
          this.AddParameterToReport('ProviderId' + i, provider, DataTypeEnum.String);
          i++;
        });
        this.AddParameterToReport('isProvider', true, DataTypeEnum.Boolean);
      }
      if (this.reportFinancialSnapshotFilter.reportFinancialSnapshotFilterModel.isPractice) {
        this.AddParameterToReport('PracticeId', this.reportFinancialSnapshotFilter.reportFinancialSnapshotFilterModel.PracticeId, DataTypeEnum.String);
        this.AddParameterToReport('isPractice', true, DataTypeEnum.Boolean);
        this.reportFinancialSnapshotFilter.reportFinancialSnapshotFilterModel.PracticeLocations.forEach(location => {
          this.AddParameterToReport('Location' + i, location, DataTypeEnum.String);
          i++;
        });
      }
      this.AddParameterToReport('showInactive', this.reportFinancialSnapshotFilter.reportFinancialSnapshotFilterModel.showInactive, DataTypeEnum.Boolean);
      this.AddParameterToReport('initialDate', this.datePipe.transform(ConversionUtilities.getInitialDate(this.reportFinancialSnapshotFilter.reportFinancialSnapshotFilterModel.initialDate), 'yyyy/MM/dd HH:mm:ss', 'UTC'), DataTypeEnum.String);
      this.AddParameterToReport('endDate', this.datePipe.transform(ConversionUtilities.getEndDate(this.reportFinancialSnapshotFilter.reportFinancialSnapshotFilterModel.endDate), 'yyyy/MM/dd HH:mm:ss', 'UTC'), DataTypeEnum.String);
      this.AddParameterToReport('OrderBy', this.reportFinancialSnapshotFilter.reportFinancialSnapshotFilterModel.OrderBy, DataTypeEnum.String);
      this.AddParameterToReport('isAsc', this.reportFinancialSnapshotFilter.reportFinancialSnapshotFilterModel.isAsc, DataTypeEnum.Boolean);
      this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
      this.AddParameterToReport('isDailySnapshot', true, DataTypeEnum.Boolean);
      this.AddParameterToReport('CurrentLOCID', this.globals.LOCID, DataTypeEnum.String);
      this.hasDevReportParam = false;
      this.showParameters();
      this.getReportUrl();
    }
  }

  frontDeskEnvelopParams() {
    this.ReportFrontDesk.sendFilterToParent();
    if (this.globals.currentPatientId === undefined || this.globals.currentPatientId === null) {
      this.snackBar.open('Please select Patient', 'TDOX', {
        duration: 3000,
        verticalPosition: 'top'
      });
      return;
    }
    if (this.reportFrontDeskFilters === undefined) {
      this.snackBar.open('Please select parameters', 'TDOX', {
        duration: 3000,
        verticalPosition: 'top'
      });
      return;
    }
    this.activeReport.cfgReportParameters = [];
    this.AddParameterToReport('PatientID', this.globals.currentPatientId.toUpperCase(), DataTypeEnum.String);
    this.AddParameterToReport('PersonContactID', this.reportFrontDeskFilters.ContactId, DataTypeEnum.String);
    this.AddParameterToReport('EnvelopSize', this.reportFrontDeskFilters.size, DataTypeEnum.String);
    this.AddParameterToReport('EnvelopFor', this.reportFrontDeskFilters.envelopFor, DataTypeEnum.String);
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();

  }

  frontDeskTreatmentPlanParams() {
    if (this.globals.currentPatientId === undefined || this.globals.currentPatientId === null) {
      this.snackBar.open('Please select Patient', 'TDOX', {
        duration: 3000,
        verticalPosition: 'top'
      });
      this.reportUrl = '';
      return;
    }
    this.ReportFrontDesk.sendFilterToParent();
    if (this.reportFrontDeskFilters === undefined || this.reportFrontDeskFilters.ParentTreatmentPlanningID === null || this.reportFrontDeskFilters.ParentTreatmentPlanningID === undefined) {
      this.snackBar.open('Please select parameters', 'TDOX', {
        duration: 3000,
        verticalPosition: 'top'
      });
      this.reportUrl = '';
      return;
    }
    this.activeReport.cfgReportParameters = [];
    this.AddParameterToReport('PatientID', this.globals.currentPatientId.toUpperCase(), DataTypeEnum.String);
    this.AddParameterToReport('TreatmentPlanningID', this.reportFrontDeskFilters.TreatmentPlanningID, DataTypeEnum.String);
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.AddParameterToReport('TDOCID', localStorage.getItem('TDOCID'), DataTypeEnum.String);
    this.AddParameterToReport('LOCID', this.globals.LOCID, DataTypeEnum.String);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }

  frontDeskWalkOutSlip() {
    this.activeReport.cfgReportParameters = [];
    if (this.globals.currentPatientId === undefined || this.globals.currentPatientId === null) {
      this.snackBar.open('Please select Patient', 'TDOX', {
        duration: 3000,
        verticalPosition: 'top'
      });
      this.reportUrl = '';
      return;
    }
    if (!this.isSpecificReport) {
      this.AddParameterToReport('PatientID', this.globals.currentPatientId.toUpperCase(), DataTypeEnum.String);
      this.AddParameterToReport('LOCID', this.globals.LOCID, DataTypeEnum.String);
    } else {
      this.AddParameterToReport('PatientID', this.reportStartUpObject.reportGlobalParameters.PatientID.toUpperCase(), DataTypeEnum.String);
      this.AddParameterToReport('LOCID', this.reportStartUpObject.reportGlobalParameters.LOCID, DataTypeEnum.String);
    }
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }

  feeCalculationReport() {
    this.activeReport.cfgReportParameters = [];
    if (this.globals.currentPatientId === undefined || this.globals.currentPatientId === null) {
      this.snackBar.open('Please select Patient', 'TDOX', {
        duration: 3000,
        verticalPosition: 'top'
      });
      this.reportUrl = '';
      return;
    }

    this.reportFeeCalculationReportFilter.sendFilterToParent();
    if (this.reportFeeCalculationReportFilter.reportFeeCalculationReportModel === undefined || this.reportFeeCalculationReportFilter.reportFeeCalculationReportModel === null) {
      this.snackBar.open('Please select parameters', 'TDOX', {
        duration: 3000,
        verticalPosition: 'top'
      });
      return;
    }


    if (!this.isSpecificReport) {
      this.AddParameterToReport('PatientID', this.globals.currentPatientId.toUpperCase(), DataTypeEnum.String);
      this.AddParameterToReport('CurrentLOCID', this.globals.LOCID, DataTypeEnum.String);
    } else {
      this.AddParameterToReport('PatientID', this.reportStartUpObject.reportGlobalParameters.PatientID.toUpperCase(), DataTypeEnum.String);
      this.AddParameterToReport('CurrentLOCID', this.reportStartUpObject.reportGlobalParameters.LOCID, DataTypeEnum.String);
    }
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.AddParameterToReport('isOrderedByDate', this.reportFeeCalculationReportFilter.reportFeeCalculationReportModel.isOrderedByDate, DataTypeEnum.Boolean);
    this.AddParameterToReport('isOrderedByToothCode', this.reportFeeCalculationReportFilter.reportFeeCalculationReportModel.isOrderedByToothCode, DataTypeEnum.Boolean);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }

  bankDeposits() {
    this.reportBankDepositsFilter.sendFilterToParent();
    if (this.reportBankDepositsFilter.reportBankDepositsModel === undefined) {
      this.snackBar.open('Please select parameters', 'TDOX', {
        duration: 3000,
        verticalPosition: 'top'
      });
      return;
    }
    this.activeReport.cfgReportParameters = [];
    this.AddParameterToReport('CurrentLOCID', this.reportStartUpObject.reportGlobalParameters.LOCID, DataTypeEnum.String);
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.AddParameterToReport('isCash', this.reportBankDepositsFilter.reportBankDepositsModel.isCash, DataTypeEnum.Boolean);
    this.AddParameterToReport('isCheck', this.reportBankDepositsFilter.reportBankDepositsModel.isCheck, DataTypeEnum.Boolean);
    this.AddParameterToReport('isCashandCheck', this.reportBankDepositsFilter.reportBankDepositsModel.isCashandCheck, DataTypeEnum.Boolean);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }

  AddParameterToReport(ParameterName: string, ParameterValue: any, enumDataTypeID: DataTypeEnum) {
    const param = new ReportParameterModel();
    if (enumDataTypeID === DataTypeEnum.String) {
      param.ParameterName = ParameterName;
      param.ParameterValueString = ParameterValue;
      param.enumDataTypeID = enumDataTypeID;
    } else if (enumDataTypeID === DataTypeEnum.Boolean) {
      param.ParameterName = ParameterName;
      param.ParameterValueBoolean = ParameterValue;
      param.enumDataTypeID = enumDataTypeID;
    } else if (enumDataTypeID === DataTypeEnum.DateTime) {
      param.ParameterName = ParameterName;
      param.ParameterValueDate = ParameterValue;
      param.enumDataTypeID = enumDataTypeID;
    } else if (enumDataTypeID === DataTypeEnum.Integer) {
      param.ParameterName = ParameterName;
      param.ParameterValueNumber = ParameterValue;
      param.enumDataTypeID = enumDataTypeID;
    }
    this.activeReport.cfgReportParameters.push(param);
  }

  getReportUrl() {

    // let oldGlobal: any = localStorage.getItem('global');
    // oldGlobal = JSON.parse(oldGlobal);

    /* if (oldGlobal != null && oldGlobal.currentPatient != null && storedUser != null && storedUser.authdata.userid != null) {
window.open('https://tdoxletterstestinternal.azurewebsites.net/new-letter/TDOx/' + oldGlobal.currentPatientCase + '/'
+ oldGlobal.currentPatient + ',_' + storedUser.authdata.userid, '_blank', 'toolbar=1,location=0,menubar=1');
} else {
// show message about selecting a patient
}*/
    // this.hostUrl = environment.tdoxReportingUrl;// + this.storedUser.authdata.userid;
    // this.authToken = this.storedUser.authToken;
    // get report path, start report dx-Report-viewer
    this.reportUrl = encodeURIComponent(this.returnReportPath());
    // and just for now...
    // this.reportName = this.reportUrl;
    // window.open(this.hostUrl + this.reportUrl , '_blank', 'toolbar=1,location=0,menubar=1');
  }

  runReportToPDF(): void {
    this.reportToPDFUrl = this.hostUrlReporting + 'ReportExport/ExportPDF?reportUrl=' + this.returnReportPath();
    this.goToLink(this.reportToPDFUrl);
  }

  goToLink(url: string): void {
    window.open(url, '_blank');
  }

  returnReportPath(): string {
    // report path return
    let reportPath = '';

    // build params for report
    reportPath = this.activeReport.ServerReportName;
    this.reportViewerParameters = [];
    let params = '';

    // if params entered
    // string params
    this.reportParametersString.forEach(a => {
      if (a.ParameterValueString) {
        const viewerParam = new ReportViewerParameterModel();
        viewerParam.value = a.ParameterValueString;
        viewerParam.name = a.ParameterName;
        if (this.reportViewerParameters.find(x => x.name === viewerParam.name)) {
          const index = this.reportViewerParameters.findIndex(x => x.name === viewerParam.name);
          this.reportViewerParameters[index].value = viewerParam.value;
        } else {
          this.reportViewerParameters.push(viewerParam);
        }
      }
    });

    // number params
    this.reportParametersNumber.forEach(a => {
      if (a.ParameterValueNumber) {
        const viewerParam = new ReportViewerParameterModel();
        viewerParam.value = a.ParameterValueNumber.toString();
        viewerParam.name = a.ParameterName;
        if (this.reportViewerParameters.find(x => x.name === viewerParam.name)) {
          const index = this.reportViewerParameters.findIndex(x => x.name === viewerParam.name);
          this.reportViewerParameters[index].value = viewerParam.value;
        } else {
          this.reportViewerParameters.push(viewerParam);
        }
      }
    });

    // boolean params
    this.reportParametersBoolean.forEach(a => {
      if (a.ParameterValueBoolean) {
        const viewerParam = new ReportViewerParameterModel();
        viewerParam.value = a.ParameterValueBoolean.toString();
        viewerParam.name = a.ParameterName;
        if (this.reportViewerParameters.find(x => x.name === viewerParam.name)) {
          const index = this.reportViewerParameters.findIndex(x => x.name === viewerParam.name);
          this.reportViewerParameters[index].value = viewerParam.value;
        } else {
          this.reportViewerParameters.push(viewerParam);
        }
      }
    });

    // date params
    this.reportParametersDateTime.forEach(a => {
      if (a.ParameterValueDate) {
        const viewerParam = new ReportViewerParameterModel();
        viewerParam.value = a.ParameterValueDate.toString();
        viewerParam.name = a.ParameterName;
        if (this.reportViewerParameters.find(x => x.name === viewerParam.name)) {
          const index = this.reportViewerParameters.findIndex(x => x.name === viewerParam.name);
          this.reportViewerParameters[index].value = viewerParam.value;
        } else {
          this.reportViewerParameters.push(viewerParam);
        }
      }
    });

    if (this.reportViewerParameters.length) {
      this.reportViewerParameters.forEach(item => {
        params += '&' + item.name + '=' + item.value;
      });
      params = params.replace('&', '?');
    }

    // finally, append params to url
    reportPath += params;
    // return report path
    return reportPath;
  }

  showMessage(type, message) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

  isChecked(ReportID: string): boolean {

    if (this.reports.length === 1 && ReportID === this.reports[0].ReportID) {
      return true;
    } else {
      return false;
    }
  }

  onTdoDropdownChange(event: MatSelectChange, row: TdoTableRowModel, enumID: string) {
    row.model[enumID] = event.value.ValidValueItemId;
  }

  getValueByEnumId(locationEnumItems: EnumValidValueItemModel[], enumEndoFractureLocationID: string
  ) {
    return locationEnumItems.find(p => p.ValidValueItemId === enumEndoFractureLocationID);
  }

  getReportCategory(enumReportCategoryID: string) {
    if (this.reportCategoryEnumItems) {
      const pri = this.reportCategoryEnumItems.find(p => p.ValidValueItemId === enumReportCategoryID);
      return pri;
    }
    return null;
  }

  onUserReportCategoryChange(event: any) {
    this.selectedEnumReportCategoryID = event.value.ValidValueItemId;
    this.selectedEnumReportCategory = event.value;
    this.blReportByCategorySelected = true;
    this.hideAllFilters();
  }

  get reportsByCategory() {
    return this.reports.filter(x => x.enumReportCategoryID === this.selectedEnumReportCategoryID && x.enumReportClassID === ReportClass.ReportViewer).sort((a, b) => a.ReportOrderInCategory - b.ReportOrderInCategory);
  }

  BeforeRender(pEvent: any) {
    pEvent.args.reportPreview.zoom(1);
  }

  onDocumentReady(pEvent: any) {
    const self = this;
    const reportPreview = self.viewer.bindingSender.GetReportPreview();
    reportPreview.zoom(0.25);
  }

  childOnChecked(isChecked: boolean) {
    this.isSnapshotDevExpress = !isChecked;
    this.reportUrl = '';
  }

  hideAllFilters() {
    this.showAgingFilters = false;
    this.showFinancialSummaryFilters = false;
    this.showFinancialSnapshotFilters = false;
    this.showFrontDeskFilters = false;
    this.hasDevReportParam = false;
  }

  transformReportName(reportName: string): string {
    return reportName.toLowerCase().replace(/\s+/g, '-');
  }
}
